import { useUserStore } from '~/stores/auth';

interface UserState {
  user: {
    nonEecUser?: boolean;
  };
}
export default defineNuxtRouteMiddleware((to) => {
  const userStore = useUserStore() as UserState;

  // Skip if already on 403 page
  if (to.path === '/403') {
    return;
  }

  if (userStore.user?.nonEecUser) {
    navigateTo('/403');
  }
});
